import type { ReactElement } from 'react';
import cx from 'clsx';
import { FieldError, type FieldErrorProps } from 'react-aria-components';
import styles from './error.module.css';

export function Error({ className, ...props }: FieldErrorProps): ReactElement {
  return (
    <FieldError
      className={cx(className, styles.error, 'caption')}
      data-test-form-elements-message
      data-test-level="error"
      {...props}
    />
  );
}
